export const SET_CURRENCIES = "SET_CURRENCIES";
export const SET_MAIN_CURRENCIES = "SET_MAIN_CURRENCIES";
